var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 36,
    viewBox: "0 0 121 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.0958 6.74512H40.3867V28.1356H54.5939V25.7412H45.0958V6.74512Z",
    fill: "#EEE0F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.422 11.5342H106.713V23.3469H109.107V25.7413H116.291V28.1358H109.107V30.5302H118.685V28.1358H121V11.5342H116.291V23.3469H111.422V11.5342Z",
    fill: "#EEE0F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5055 9.13965H97.2146V13.8488H104.398V16.2432H97.2146V25.7413H102.004V28.1357H94.9V25.7413H92.5055V16.2432H90.0312V13.8488H92.5055V9.13965Z",
    fill: "#EEE0F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.801 11.5342H59.3827V13.9286H56.9883V25.7413H59.3827V28.1358H68.801V25.7413H71.1156V13.9286H68.801V11.5342ZM66.4065 13.9286H61.6974V25.7413H66.4065V13.9286Z",
    fill: "#EEE0F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.3224 11.5342H75.9042V13.9286H73.5098V25.7413H75.9042V28.1358H85.3224V25.7413H87.6371V13.9286H85.3224V11.5342ZM82.928 13.9286H78.2189V25.7413H82.928V13.9286Z",
    fill: "#EEE0F9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.74736 8.15347L8.62078 8.15347V6.7168L22.9875 6.7168V8.15347L25.8608 8.15347V9.59014H28.7341V11.0268L30.1709 11.0268V29.7035L1.4375 29.7035L1.4375 11.0268H2.87401V9.59014H5.74736V8.15347Z",
    fill: "#090711"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1699 28.2674L30.1699 29.7041L31.6066 29.7041L31.6066 28.2674L30.1699 28.2674Z",
    fill: "#EEE0F9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7344 29.704L28.7344 31.1406L30.171 31.1406L30.171 29.704L28.7344 29.704Z",
    fill: "#EEE0F9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1699 26.8309L30.1699 28.2676L31.6066 28.2676L31.6066 26.8309L30.1699 26.8309Z",
    fill: "#EEE0F9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1699 25.3934L30.1699 26.8301L31.6066 26.8301L31.6066 25.3934L30.1699 25.3934Z",
    fill: "#EEE0F9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1699 23.9569L30.1699 25.3936L31.6066 25.3936L31.6066 23.9569L30.1699 23.9569Z",
    fill: "#EEE0F9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1699 22.5204L30.1699 23.957L31.6066 23.957L31.6066 22.5204L30.1699 22.5204Z",
    fill: "#EEE0F9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1699 21.0838L30.1699 22.5205L31.6066 22.5205L31.6066 21.0838L30.1699 21.0838Z",
    fill: "#EEE0F9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1699 19.6473L30.1699 21.084L31.6066 21.084L31.6066 19.6473L30.1699 19.6473Z",
    fill: "#EEE0F9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1699 18.2108L30.1699 19.6475L31.6066 19.6475L31.6066 18.2108L30.1699 18.2108Z",
    fill: "#EEE0F9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1699 16.7743L30.1699 18.2109L31.6066 18.2109L31.6066 16.7743L30.1699 16.7743Z",
    fill: "#EEE0F9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1699 15.3368L30.1699 16.7734L31.6066 16.7734L31.6066 15.3368L30.1699 15.3368Z",
    fill: "#EEE0F9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1699 13.9012L30.1699 15.3379L31.6066 15.3379L31.6066 13.9012L30.1699 13.9012Z",
    fill: "#EEE0F9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1699 12.4637L30.1699 13.9004L31.6066 13.9004L31.6066 12.4637L30.1699 12.4637Z",
    fill: "#EEE0F9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1699 11.0272L30.1699 12.4639L31.6066 12.4639L31.6066 11.0272L30.1699 11.0272Z",
    fill: "#EEE0F9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1699 9.59067L30.1699 11.0273L31.6066 11.0273L31.6066 9.59067L30.1699 9.59067Z",
    fill: "#EEE0F9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7344 9.59067L28.7344 11.0273L30.171 11.0273L30.171 9.59067L28.7344 9.59067Z",
    fill: "#EEE0F9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7344 8.15415L28.7344 9.59082L30.171 9.59082L30.171 8.15415L28.7344 8.15415Z",
    fill: "#EEE0F9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2969 8.15415L27.2969 9.59082L28.7335 9.59082L28.7335 8.15415L27.2969 8.15415Z",
    fill: "#EEE0F9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8613 8.15415L25.8613 9.59082L27.298 9.59082L27.298 8.15415L25.8613 8.15415Z",
    fill: "#EEE0F9"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8613 6.71665L25.8613 8.15332L27.298 8.15332L27.298 6.71665L25.8613 6.71665Z",
    fill: "#EEE0F9"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4238 6.71665L24.4238 8.15332L25.8605 8.15332L25.8605 6.71665L24.4238 6.71665Z",
    fill: "#EEE0F9"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9863 6.71665L22.9863 8.15332L24.423 8.15332L24.423 6.71665L22.9863 6.71665Z",
    fill: "#EEE0F9"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9863 5.28013L22.9863 6.7168L24.423 6.7168L24.423 5.28012L22.9863 5.28013Z",
    fill: "#EEE0F9"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1.4375 28.2674L1.4375 29.7041L0.000828147 29.7041L0.00082821 28.2674L1.4375 28.2674Z",
    fill: "#EEE0F9"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7344 29.704L28.7344 31.1406L1.43761 31.1406L1.43761 29.704L28.7344 29.704Z",
    fill: "#EEE0F9"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1.4375 26.8309L1.4375 28.2676L0.000828147 28.2676L0.00082821 26.8309L1.4375 26.8309Z",
    fill: "#EEE0F9"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1.4375 25.3934L1.4375 26.8301L0.000828147 26.8301L0.00082821 25.3934L1.4375 25.3934Z",
    fill: "#EEE0F9"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1.4375 23.9569L1.4375 25.3936L0.000828147 25.3936L0.00082821 23.9569L1.4375 23.9569Z",
    fill: "#EEE0F9"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1.4375 22.5204L1.4375 23.957L0.000828147 23.957L0.00082821 22.5204L1.4375 22.5204Z",
    fill: "#EEE0F9"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1.4375 21.0838L1.4375 22.5205L0.000828147 22.5205L0.00082821 21.0838L1.4375 21.0838Z",
    fill: "#EEE0F9"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1.4375 19.6473L1.4375 21.084L0.000828147 21.084L0.00082821 19.6473L1.4375 19.6473Z",
    fill: "#EEE0F9"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1.4375 18.2108L1.4375 19.6475L0.000828147 19.6475L0.00082821 18.2108L1.4375 18.2108Z",
    fill: "#EEE0F9"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1.4375 16.7743L1.4375 18.2109L0.000828147 18.2109L0.00082821 16.7743L1.4375 16.7743Z",
    fill: "#EEE0F9"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1.4375 15.3368L1.4375 16.7734L0.000828147 16.7734L0.00082821 15.3368L1.4375 15.3368Z",
    fill: "#EEE0F9"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1.4375 13.9012L1.4375 15.3379L0.000828147 15.3379L0.00082821 13.9012L1.4375 13.9012Z",
    fill: "#EEE0F9"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1.4375 12.4637L1.4375 13.9004L0.000828147 13.9004L0.00082821 12.4637L1.4375 12.4637Z",
    fill: "#EEE0F9"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M1.4375 11.0272L1.4375 12.4639L0.000828147 12.4639L0.00082821 11.0272L1.4375 11.0272Z",
    fill: "#EEE0F9"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M1.4375 9.59067L1.4375 11.0273L0.000828147 11.0273L0.00082821 9.59067L1.4375 9.59067Z",
    fill: "#EEE0F9"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M2.87305 9.59067L2.87305 11.0273L1.43638 11.0273L1.43638 9.59067L2.87305 9.59067Z",
    fill: "#EEE0F9"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M2.87305 8.15415L2.87305 9.59082L1.43638 9.59082L1.43638 8.15415L2.87305 8.15415Z",
    fill: "#EEE0F9"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M4.31055 8.15415L4.31055 9.59082L2.87388 9.59082L2.87388 8.15415L4.31055 8.15415Z",
    fill: "#EEE0F9"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M5.74609 8.15415L5.74609 9.59082L4.30942 9.59082L4.30942 8.15415L5.74609 8.15415Z",
    fill: "#EEE0F9"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M5.74609 6.71665L5.74609 8.15332L4.30942 8.15332L4.30942 6.71665L5.74609 6.71665Z",
    fill: "#EEE0F9"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M7.18359 6.71665L7.18359 8.15332L5.74692 8.15332L5.74692 6.71665L7.18359 6.71665Z",
    fill: "#EEE0F9"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M8.62109 6.71665L8.62109 8.15332L7.18442 8.15332L7.18442 6.71665L8.62109 6.71665Z",
    fill: "#EEE0F9"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M8.62109 5.28013L8.62109 6.7168L7.18442 6.7168L7.18442 5.28012L8.62109 5.28013Z",
    fill: "#EEE0F9"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M8.62109 5.28013L8.62109 6.7168L22.9878 6.7168L22.9878 5.28012L8.62109 5.28013Z",
    fill: "#EEE0F9"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8613 21.0838L25.8613 22.5205L27.298 22.5205L27.298 21.0838L25.8613 21.0838Z",
    fill: "#EEE0F9"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M4.31055 21.0838L4.31055 22.5205L5.74722 22.5205L5.74722 21.0838L4.31055 21.0838Z",
    fill: "#EEE0F9"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M5.74805 19.6463L5.74805 21.083L1.43803 21.083L1.43803 19.6463L5.74805 19.6463Z",
    fill: "#EEE0F9"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M4.31055 21.0838L4.31055 22.5205L1.4372 22.5205L1.4372 21.0838L4.31055 21.0838Z",
    fill: "#EEE0F9"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0586 22.5204L10.0586 23.957L4.31191 23.957L4.31191 22.5204L10.0586 22.5204Z",
    fill: "#EEE0F9"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2969 21.0838L27.2969 22.5205L30.1702 22.5205L30.1702 21.0838L27.2969 21.0838Z",
    fill: "#EEE0F9"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5508 22.5204L21.5508 23.957L27.2975 23.957L27.2975 22.5204L21.5508 22.5204Z",
    fill: "#EEE0F9"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0586 21.0838L10.0586 22.5205L5.74858 22.5205L5.74858 21.0838L10.0586 21.0838Z",
    fill: "#EEE0F9"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8613 21.0838L25.8613 22.5205L21.5513 22.5205L21.5513 21.0838L25.8613 21.0838Z",
    fill: "#EEE0F9"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1719 19.6463L30.1719 21.083L25.8619 21.083L25.8619 19.6463L30.1719 19.6463Z",
    fill: "#EEE0F9"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4668 23.9569L6.4668 25.3936L7.90347 25.3936L7.90347 23.9569L6.4668 23.9569Z",
    fill: "#EEE0F9"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M7.90234 23.9569L7.90234 25.3936L22.2691 25.3936L22.2691 23.9569L7.90234 23.9569Z",
    fill: "#EEE0F9"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M7.90234 25.3934L7.90234 26.8301L9.33902 26.8301L9.33902 25.3934L7.90234 25.3934Z",
    fill: "#EEE0F9"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33984 25.3934L9.33984 26.8301L10.7765 26.8301L10.7765 25.3934L9.33984 25.3934Z",
    fill: "#EEE0F9"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0586 22.5204L10.0586 23.957L11.4953 23.957L11.4953 22.5204L10.0586 22.5204Z",
    fill: "#EEE0F9"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4941 26.8302L11.4941 27.4688L20.1142 27.4687L20.1142 26.8302L11.4941 26.8302Z",
    fill: "#EEE0F9"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4941 23.3185L11.4941 23.957L20.1142 23.957L20.1142 23.3185L11.4941 23.3185Z",
    fill: "#EEE0F9"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1426 23.9569L25.1426 25.3936L23.7059 25.3936L23.7059 23.9569L25.1426 23.9569Z",
    fill: "#EEE0F9"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7051 23.9569L23.7051 25.3936L22.2684 25.3936L22.2684 23.9569L23.7051 23.9569Z",
    fill: "#EEE0F9"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7051 25.3934L23.7051 26.8301L22.2684 26.8301L22.2684 25.3934L23.7051 25.3934Z",
    fill: "#EEE0F9"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2695 25.3934L22.2695 26.8301L10.7762 26.8301L10.7762 25.3934L22.2695 25.3934Z",
    fill: "#EEE0F9"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5508 22.5204L21.5508 23.957L20.1141 23.957L20.1141 22.5204L21.5508 22.5204Z",
    fill: "#EEE0F9"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1719 18.2098L30.1719 19.6465L28.7352 19.6465L28.7352 18.2098L30.1719 18.2098Z",
    fill: "#EEE0F9"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M2.875 18.2098L2.875 19.6465L1.43833 19.6465L1.43833 18.2098L2.875 18.2098Z",
    fill: "#EEE0F9"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M5.74805 13.9002L5.74805 15.3369L7.18472 15.3369L7.18472 13.9002L5.74805 13.9002Z",
    fill: "#EEE0F9"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M7.18359 12.4627L7.18359 13.8994L5.74692 13.8994L5.74692 12.4627L7.18359 12.4627Z",
    fill: "#EEE0F9"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M5.74805 13.9002L5.74805 15.3369L4.31138 15.3369L4.31138 13.9002L5.74805 13.9002Z",
    fill: "#EEE0F9"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4941 15.3368L11.4941 16.7734L5.74745 16.7734L5.74745 15.3368L11.4941 15.3368Z",
    fill: "#EEE0F9"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4941 13.9002L11.4941 15.3369L7.18413 15.3369L7.18413 13.9002L11.4941 13.9002Z",
    fill: "#EEE0F9"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4941 15.3368L11.4941 16.7734L12.9308 16.7734L12.9308 15.3368L11.4941 15.3368Z",
    fill: "#EEE0F9"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0566 16.7733L10.0566 18.21L11.4933 18.21L11.4933 16.7733L10.0566 16.7733Z",
    fill: "#EEE0F9"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M8.62109 16.7733L8.62109 18.21L10.0578 18.21L10.0578 16.7733L8.62109 16.7733Z",
    fill: "#EEE0F9"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M7.18359 16.7733L7.18359 18.21L8.62027 18.21L8.62027 16.7733L7.18359 16.7733Z",
    fill: "#EEE0F9"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8594 13.9002L25.8594 15.3369L24.4227 15.3369L24.4227 13.9002L25.8594 13.9002Z",
    fill: "#EEE0F9"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4238 12.4627L24.4238 13.8994L25.8605 13.8994L25.8605 12.4627L24.4238 12.4627Z",
    fill: "#EEE0F9"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8594 13.9002L25.8594 15.3369L27.296 15.3369L27.296 13.9002L25.8594 13.9002Z",
    fill: "#EEE0F9"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1133 15.3368L20.1133 16.7734L25.86 16.7734L25.86 15.3368L20.1133 15.3368Z",
    fill: "#EEE0F9"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1133 13.9002L20.1133 15.3369L24.4233 15.3369L24.4233 13.9002L20.1133 13.9002Z",
    fill: "#EEE0F9"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1133 15.3368L20.1133 16.7734L18.6766 16.7734L18.6766 15.3368L20.1133 15.3368Z",
    fill: "#EEE0F9"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5508 16.7733L21.5508 18.21L20.1141 18.21L20.1141 16.7733L21.5508 16.7733Z",
    fill: "#EEE0F9"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9863 16.7733L22.9863 18.21L21.5497 18.21L21.5497 16.7733L22.9863 16.7733Z",
    fill: "#EEE0F9"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4238 16.7733L24.4238 18.21L22.9872 18.21L22.9872 16.7733L24.4238 16.7733Z",
    fill: "#EEE0F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppLogo);
export default __webpack_public_path__ + "static/media/app-logo.3ee6a2b1bc010b8ff02c908bcc117bd1.svg";
export { ForwardRef as ReactComponent };